import { AuthService, type GroupRequestV1Dto, type UserV1Dto } from '@/openapi';
import { eventBus } from '@/configs/eventBus';

import type { SimpleProfile } from '../profileTypes';

export function useProfile() {
  const fetchProfile = async () => {
    try {
      return await AuthService.entraAuthControllerV1GetProfileV1();
    } catch (err) {
      console.log(err);
    }
  };

  const switchGroup = async (data: GroupRequestV1Dto) => {
    try {
      await AuthService.entraAuthControllerV1SwitchGroupV1(data);
      eventBus.emit('update');
    } catch (err) {
      console.log(err);
    }
  };

  return { fetchProfile, switchGroup };
}

export function useProfileConverter() {
  const convertToSimpleProfile = (data: UserV1Dto): SimpleProfile => {
    const { email, isSeyboldUser, userName, userId } = data;
    return {
      email: email,
      groups: data.groups,
      isSeyboldUser: isSeyboldUser,
      userId: userId,
      userName: userName,
    };
  };

  return { convertToSimpleProfile };
}
